import '../scss/liveDetail.scss';
import $ from 'jquery';
import videojs from 'video.js';
import Swiper from 'swiper';
import throttle from 'lodash/throttle';
import Player from 'video.js/dist/types/player';
import Lazyload from 'lazyload';
import {
  browerVersion,
  getBrowerAppId,
  getSingleValueFromInput,
} from './utils';
import 'video.js/dist/video-js.min.css';
import 'swiper/css';
import {
  fetchAddReadCountByLog,
  fetchCommentJson,
  fetchLiveJson,
  fetchNoLiveJson,
  fetchPreviewComment,
  fetchPreviewLiveReport,
  fetchPreviewNoliveReport,
  fetchSiteJson,
  fetechSceneVisitCount,
} from '../apis/api';
import initWxSdk from './wxSdk';
import YouMeng from './YouMeng';
import NanFang from './NanFang';

const liveState1 = require('../assets/images/live-state-1.png');
const liveState2 = require('../assets/images/live-state-2.png');
const liveState3 = require('../assets/images/live-state-3.png');
const noliveIcon = require('../assets/images/no-live-icon.png');
const liveUpsideDown = require('../assets/images/live-nolive-upside-down.png');
const contentLoadingImg = require('../assets/images/content-loading.png');
const emptyPlayback = require('../assets/images/empty-playback.png');

const liveState = getSingleValueFromInput('liveState');
const liveType = getSingleValueFromInput('liveType');
const liveJson = getSingleValueFromInput('liveJson');
const commentUrl = getSingleValueFromInput('commentJson');
const noLiveJson = getSingleValueFromInput('noLiveJson');
const noLiveJsonDesc = getSingleValueFromInput('noLiveJsonDesc');
const staticType = Number(getSingleValueFromInput('staticType'));
const liveId = getSingleValueFromInput('newsId');
const { clientHeight: bodyHeight, clientWidth: bodyWidth } = document.body;
const version = browerVersion();
const lazyImage = process.env.DEFAULT_IMAGE_16_9;

/**
 * 增加阅读量
 */
const addReadCount = () => {
  const newsId = getSingleValueFromInput('newsId');
  const contentType = getSingleValueFromInput('contentType');
  const siteId = getSingleValueFromInput('siteId');
  if (newsId && contentType && siteId) {
    fetchAddReadCountByLog(newsId, Number(contentType), siteId);
  }
};

/**
 * 获取sitejson
 * 将打开app的按钮初始化
 */
const initSiteJson = () => {
  if (!version.myApp) {
    fetchSiteJson().then((res: Site.SiteJson) => {
      $('a[name="download-link"]')
        .attr('data-href', res.downloadUrl)
        .attr('alt', res.name);
    });
    if (Number(liveState) === 2 || Number(liveState) === 3) {
      initWxSdk({
        launchAppBtn: [
          {
            attr: 'id',
            value: 'live-launch-app-box',
          },
          {
            attr: 'class',
            value: 'live-poster-box',
          },
        ],
      });
    } else if (Number(liveState) === 1) {
      initWxSdk({
        launchAppBtn: [
          {
            attr: 'id',
            value: 'live-subscribe-box',
          },
          {
            attr: 'class',
            value: 'live-poster-box',
          },
        ],
      });
    }
  }
};

/**
 * 初始化直播头部的图片空间
 * 并根据图片的宽高设置下方轮播区的高度
 * 并根据直播状态设置不同的高度
 */
const loadLiveImage = () => {
  const liveImage = $('.live-header-image');
  if (!liveImage || !liveImage.length) {
    return;
  }
  liveImage.each((_, el) => {
    $(el).one('load', (evt) => {
      const { clientHeight } = evt.target as HTMLImageElement;
      if (Number(liveState) === 1) {
        const leftHeight = bodyHeight - clientHeight - 48;
        $('.live-body').css({ height: `${leftHeight}px` });
      } else {
        const leftHeight = bodyHeight - clientHeight - 94;
        $('.live-slide').css({ height: `${leftHeight}px` });
      }
    });
    if ((el as HTMLImageElement).complete) {
      const { clientHeight } = el;
      if (Number(liveState) === 1) {
        const leftHeight = bodyHeight - clientHeight - 48;
        $('.live-body').css({ height: `${leftHeight}px` });
      } else {
        const leftHeight = bodyHeight - clientHeight - 94;
        $('.live-slide').css({ height: `${leftHeight}px` });
      }
    }
  });
};

let liveVideoPlayer: Player;
const nolivePlayers: Player[] = [];
/**
 * 初始化直播头部的视频空间
 * 并根据视频的宽高设置下方轮播区的高度
 * 并根据直播状态设置不同的高度
 * 当点击顶部的视频播放时，需要将图文直播中的视频暂停
 */
const loadLiveVideo = () => {
  const liveVideo = $('.live-header-video');
  if (!liveVideo || !liveVideo.length) {
    return;
  }
  liveVideoPlayer = videojs(
    document.querySelector('.live-header-video') as Element,
    {
      autoplay: true,
      aspectRatio: '16:9',
      controls: true,
      playbackRates: [0.75, 1, 1.25, 1.5, 2],
      poster: liveVideo.attr('poster') || process.env.DEFAULT_IMAGE_16_9,
      language: 'zh-CN',
    },
  );
  liveVideoPlayer.on('error', () => {});
  liveVideoPlayer.on('play', () => {
    nolivePlayers.forEach((player) => {
      if (!player.paused()) {
        player.pause();
      }
    });
  });
  let videoHeight = (bodyWidth * 9) / 16;
  if (bodyWidth > 650) {
    videoHeight = (650 * 9) / 16;
  }
  if (Number(liveState) === 1) {
    const leftHeight = bodyHeight - videoHeight - 48;
    $('.live-body').css({ height: `${leftHeight}px` });
  } else {
    const leftHeight = bodyHeight - videoHeight - 94;
    $('.live-slide').css({ height: `${leftHeight}px` });
  }
};

/**
 * 当顶部既没有视频也没有图片时
 * 设置高度时可以去掉这部分空间
 * @returns
 */
const loadNothing = () => {
  const liveVideo = $('.live-header-video');
  const liveImage = $('.live-header-image');
  if ((liveVideo && liveVideo.length) || (liveImage && liveImage.length)) {
    return;
  }
  if (Number(liveState) === 1) {
    const leftHeight = bodyHeight - 48;
    $('.live-body').css({ height: `${leftHeight}px` });
  } else {
    const leftHeight = bodyHeight - 94;
    $('.live-slide').css({ height: `${leftHeight}px` });
  }
};

/**
 * 处理预告时的直播样式
 */
const initPreviewBox = () => {
  loadLiveImage();
  loadLiveVideo();
  loadNothing();
  const liveSubscribe = $('.live-subscribe');
  if (liveSubscribe && liveSubscribe.length) {
    liveSubscribe.css({
      width: `${bodyWidth > 650 ? 650 * 0.85 : bodyWidth * 0.85}px`,
    });
  }
};
/**
 * 直播中、回放的部分样式处理
 */
const initPlayingAndPlaybackBox = () => {
  loadLiveImage();
  loadLiveVideo();
  loadNothing();
  const liveLaunchApp = $('.live-launch-app');
  if (liveLaunchApp && liveLaunchApp.length) {
    liveLaunchApp.css({
      width: `${bodyWidth > 650 ? 650 * 0.85 : bodyWidth * 0.85}px`,
    });
  }
};

/**
 * 增加loading样式
 * @param node1
 * @param node2
 * @param scrollTop
 */
const addLiveLoadingIcon = (
  node1: JQuery<HTMLElement>,
  node2: JQuery<HTMLElement>,
  scrollTop: number,
) => {
  node1.append(
    `<div class="live-content-loading"><img src="${contentLoadingImg}" class="live-content-loading-img" alt="正在加载..."></div>`,
  );
  node2.scrollTop(scrollTop + 40);
};

let liveSwiper: Swiper;
const liveSlideNames: string[] = [];
/**
 * 初始化直播中、回放时下方的轮播区间
 * 当发生划动时，设置顶部的轮播的标题active
 * 初始化顶部的标题点击
 * 点击后，设置标题active同时设置下方的轮播图划动到对应位置
 */
const initSwiper = () => {
  const liveSlideTitles = $('.live-slide-title-box');
  liveSlideTitles.each((_, el) => {
    liveSlideNames.push(el.dataset.name as string);
  });
  liveSwiper = new Swiper('#live-slide-content', {
    on: {
      slideChange(swiper) {
        const { realIndex } = swiper;
        const liveSlide = $('.live-slide-title-box')[realIndex];
        if (liveSlide) {
          $('.live-slide-title-active').removeClass('live-slide-title-active');
          $(liveSlide).addClass('live-slide-title-active');
        }
        nolivePlayers.forEach((player) => {
          if (!player.paused()) {
            player.pause();
          }
        });
      },
    },
  });

  $('.live-slide-title-list').on('click', '.live-slide-title-box', (evt) => {
    const liveSlideTitle = $(evt.currentTarget);
    if (liveSlideTitle.hasClass('live-slide-title-active')) {
      return;
    }
    const { name: slideName } = evt.currentTarget.dataset;
    $('.live-slide-title-active').removeClass('live-slide-title-active');
    liveSlideTitle.addClass('live-slide-title-active');
    if (slideName) {
      const slideIndex = liveSlideNames.indexOf(slideName);
      if (slideIndex > -1) {
        liveSwiper.slideTo(slideIndex);
      }
    }
  });
};
/**
 * 根据评论生成html
 * @param comment
 * @returns
 */
const getCommentHtml = (comment: RMT.LiveCommentData) => {
  const avatarHtml = `<img class="live-comment-avatar" src="${
    comment.userHead || process.env.DEFAULT_AVATAR
  }" loading="lazy">`;
  const nameHtml = `<div class="live-comment-name">${comment.userName}</div>`;
  const contentHtml = `<div class="live-comment-text">${comment.content}</div>`;
  const rightHtml = `<div class="live-comment-right">${nameHtml}${contentHtml}</div>`;
  return `<div class="live-comment-box">${avatarHtml}${rightHtml}</div>`;
};
/**
 * 渲染评论列表
 * @param list
 */
const renderCommentList = (list: RMT.LiveCommentData[]) => {
  const htmls = list.map((item) => getCommentHtml(item));
  $('#live-comment-body').append(htmls.join(''));
};
let nextCommentUrl: string | boolean;
let commentPageNum = 1;
let isLoading = false;
/**
 * 当加载全部评论后，底部增加已加载全部内容的提示，并移除滚动的监听
 */
const addCommentFinish = () => {
  if (!nextCommentUrl) {
    $('#live-comment-body').off('scroll');
    $('#live-comment-body').append(
      '<div class="live-content-finish">已加载全部内容</div>',
    );
  }
};
/**
 * 当还有更多评论时，加载更多评论
 * 若已经发布，则根据nextCommentUrl是否为空判断是否还存在更多评论
 * 若尚未发布，则根据nextCommentUrl是否为true判断是否还存在更多评论
 */
const getNextComment = async () => {
  let res: RMT.LiveComment | RMT.PreviewLiveComment;
  if (
    staticType === 1 &&
    typeof nextCommentUrl === 'string' &&
    nextCommentUrl
  ) {
    res = await fetchCommentJson(nextCommentUrl);
    nextCommentUrl = res.nextJsonUrl;
    if (res.data && res.data.length) {
      renderCommentList(res.data);
    }
  } else if (
    staticType === 7 &&
    typeof nextCommentUrl === 'boolean' &&
    nextCommentUrl
  ) {
    commentPageNum += 1;
    res = await fetchPreviewComment(liveId, commentPageNum);
    if (res.list && res.list.length) {
      renderCommentList(res.list);
    }
    nextCommentUrl = res.pageNum < res.pages;
  }
  isLoading = false;
  const loadingDom = $('#live-comment-body').find('.live-content-loading');
  if (loadingDom && loadingDom.length) {
    loadingDom.remove();
  }
  addCommentFinish();
};
/**
 * 初始化获取评论功能
 * 若已经发布，通过commentjson获取评论内容，并根据返回的nextJsonUrl判断是否还有更多评论
 * 若尚未发布，通过接口获取评论内容，并根据返回的pages与pageNum的相对关系判断是否还有更多评论
 * 初始化评论的滚动监听，若滚动到底部，则请求更多评论
 * 并则更加定时发送请求，若内容滚动时，则暂停倒计时
 */
let commentTimeout = 0;
let firstCommentId = '';
const initLiveComment = async () => {
  let res: RMT.LiveComment | RMT.PreviewLiveComment;
  let data: RMT.LiveCommentData[] = [];
  if (staticType === 1) {
    res = await fetchCommentJson(commentUrl);
    nextCommentUrl = res.nextJsonUrl;
    if (res.data && res.data.length) {
      data = res.data;
    }
    if (commentTimeout) {
      window.clearTimeout(commentTimeout);
    }
    commentTimeout = window.setTimeout(() => {
      initLiveComment();
    }, 30 * 1000);
  } else {
    res = await fetchPreviewComment(liveId, commentPageNum);
    nextCommentUrl = res.pageNum < res.pages;
    if (res.list && res.list.length) {
      data = res.list;
    }
  }
  if (data && data.length && firstCommentId !== data[0].id) {
    firstCommentId = data[0].id;
    $('#live-comment-body').empty();
    renderCommentList(data);
    addCommentFinish();
  }
  $('#live-comment-body').on(
    'scroll',
    throttle((scrollEvt) => {
      if (staticType === 1) {
        if (commentTimeout) {
          window.clearTimeout(commentTimeout);
        }
        commentTimeout = window.setTimeout(() => {
          initLiveComment();
        }, 30 * 1000);
      }
      const { offsetHeight, scrollHeight, scrollTop } = scrollEvt.currentTarget;
      if (offsetHeight + scrollTop + 20 > scrollHeight) {
        if (!isLoading && nextCommentUrl) {
          addLiveLoadingIcon(
            $('#live-comment-body'),
            $(scrollEvt.currentTarget),
            scrollTop,
          );
          isLoading = true;
          getNextComment();
        }
      }
    }, 250),
  );
};
/**
 * 获取直播的阅读量
 */
const initSceneVisitCount = () => {
  const liveViewCount = $('.live-view-count');
  if (liveId && liveViewCount && liveViewCount.length) {
    fetechSceneVisitCount(liveId).then((res) => {
      if (!res) {
        $('.live-view-count').hide();
      }
      if (Number(res.status) === 200) {
        const { visitCount } = res;
        const visitCountNum = Number(visitCount);
        let visitCountText: number | string = visitCountNum;
        if (visitCountNum > 10000) {
          visitCountText = `${Math.ceil(visitCountNum / 1000) / 10}万`;
        }
        $('.live-view-count-text').text(visitCountText);
      } else {
        $('.live-view-count').hide();
      }
    });
  }
};

let currentSceneId = '';
/**
 * 设置当前正在查看的直播现场
 * 若当前现场为直播预告
 * - 若原现场正在显示视频，则移除视频并设置为图片，并调用loadLiveVideo
 * - 若原现场正在显示图片，则只需要替换图片
 * 若当前现场为直播中
 * - 若原现场正在显示视频，则替换视频源
 * - 若原现场正在显示图片，则移除图片并设置为视频，并调用loadLiveVideo
 * 若当前现场为回放并设置了回放视频则显示回放视频，其他按照直播中的逻辑处理
 * 若当前现场为回放但是没有设置回放视频，则显示直播流，并按照直播中的逻辑处理
 * @param live
 */
const setSceneLive = (live: RMT.LiveJsonData) => {
  currentSceneId = live.id;
  const liveImage = $('.live-header-image');
  const liveVideo = $('.live-header-video');
  if (live.liveType === 1) {
    if (liveVideo && liveVideo.length) {
      liveVideo.remove();
    }
    if (liveImage && liveImage.length) {
      liveImage.attr('src', live.liveCover_s || live.liveCover);
    } else {
      $('.live-header').prepend(
        `<img class="live-header-image" src="${
          live.liveCover_s || live.liveCover
        }">`,
      );
      loadLiveImage();
    }
  } else if (live.liveType === 2 || live.liveType === 3) {
    let videoSrc = '';
    if (live.liveType === 2 && (live.liveAddress || live.h5LiveAddress)) {
      videoSrc = live.liveAddress || live.h5LiveAddress;
    } else if (
      live.liveType === 3 &&
      (live.playbackAddress || live.videoOsspath)
    ) {
      videoSrc = live.playbackAddress || live.videoOsspath;
    }
    if (videoSrc) {
      if (liveImage && liveImage.length) {
        liveImage.remove();
      }
      if (liveVideo && liveVideo.length) {
        console.debug(videoSrc, live.liveCover_s);
        liveVideoPlayer.src(videoSrc);
        liveVideoPlayer.poster(live.liveCover_s || live.liveCover);
      } else {
        $('.live-header')
          .prepend(`<video webkit-playsinline="true" playsinline="true" x5-video-player-type="h5" class="live-header-video video-js" poster="${
          live.liveCover_s || live.liveCover
        }">
            <source src="${videoSrc}" />
          </video>`);
        loadLiveVideo();
      }
    } else if (live.liveType === 3) {
      if (liveVideo && liveVideo.length) {
        liveVideo.remove();
      }
      if (liveImage && liveImage.length) {
        if (bodyWidth > 650) {
          liveImage.css({ height: '362px' });
        }
        liveImage.attr('src', emptyPlayback);
      } else {
        $('.live-header').prepend(
          `<img class="live-header-image" style="height: ${bodyWidth > 650 ? '362px' : '56.25vw'}" src="${emptyPlayback}">`,
        );
        loadLiveImage();
      }
    }
  }
};

/**
 * 生成多现场html
 * @param live
 * @returns
 */
const getSceneHtml = (live: RMT.LiveJsonData) => {
  const liveSceneTitle = `<div class="live-scene-title">${live.title}</div>`;
  const liveSceneImage = `<img class="live-scene-image" src="${lazyImage}" data-src="${
    live.liveCover_s || live.liveCover
  }">`;
  let sceneStateIcon = '';
  if (live.liveType === 1) {
    sceneStateIcon = liveState1;
  } else if (live.liveType === 2) {
    sceneStateIcon = liveState2;
  } else if (live.liveType === 3) {
    sceneStateIcon = liveState3;
  }
  const liveSceneState = `<img class="live-scene-state" src="${sceneStateIcon}">`;
  const liveSceneImageBox = `<div class="live-scene-image-box">${liveSceneImage}${liveSceneState}</div>`;
  return `<div data-id="${live.id}" class="live-scene-box">${liveSceneTitle}${liveSceneImageBox}</div>`;
};

let nextLiveJsonUrl: string | boolean = '';
const liveSceneList: RMT.LiveJsonData[] = [];
/**
 * 渲染多现场效果
 * 由于避免过多图片同时加载，增加lazyload
 * @param list
 */
const renderSceneList = (list: RMT.LiveJsonData[]) => {
  const htmls = list.map((item) => {
    liveSceneList.push(item);
    return getSceneHtml(item);
  });
  $('#live-scene-body').append(htmls.join(''));
  const images = $('#live-scene-body').find('.live-scene-image');
  const sceneImages = images.filter(
    (index, el) => $(el).attr('src') !== $(el).attr('data-src'),
  );
  new Lazyload(sceneImages);
};

/**
 * 获取更多的多现场
 * 由于通过接口时，一次性返回所有数据，因此不需要加载更多
 */
const getNextLiveScene = () => {
  if (typeof nextLiveJsonUrl === 'string' && nextLiveJsonUrl) {
    fetchLiveJson(nextLiveJsonUrl).then((res) => {
      isLoading = false;
      const loadingDom = $('#live-scene-body').find('.live-content-loading');
      if (loadingDom && loadingDom.length) {
        loadingDom.remove();
      }
      if (!res) {
        return;
      }
      const { data = [], nextJsonUrl } = res;
      renderSceneList(data);
      nextLiveJsonUrl = nextJsonUrl;
      if (!nextLiveJsonUrl) {
        $('#live-scene-body').off('scroll');
      }
    });
  }
};

/**
 * 初始化多现场
 * 若已经发布，则通过livejson获取多现场数据
 * 若未发布，则通过接口获取多现场数据
 * 若不存在多现场，则清除顶部的图片和视频并移除轮播以及轮播标题，并loadNothing
 * 若只存在一个多现场，则设置顶部的数据为当前的现场并移除轮播以及轮播标题
 * 若存在多个多现场，则自动划动到多现场的轮播、监听多现场的点击事件
 * 若还有更多多现场数据时，则增加多现场的滚动到底监听
 */
const initLiveScene = async () => {
  let res: RMT.LiveJson | RMT.PreviewLiveReport;
  let data: RMT.LiveJsonData[] = [];
  let nextJsonUrl = '';
  console.log(staticType);
  if (staticType === 1) {
    res = await fetchLiveJson(liveJson);
    data = res.data;
    nextJsonUrl = res.nextJsonUrl;
  } else {
    res = await fetchPreviewLiveReport(liveId);
    data = res.list;
    nextLiveJsonUrl = false;
  }
  console.log('res', res);
  // const liveVideo = $('.live-header-video');
  // 当存在多现场时 length >= 1
  if (data && data.length >= 1) {
    setSceneLive(data[0]);
  }
  const defaultTab = Number(getSingleValueFromInput('defaultTab'));
  console.log('defaultTab', defaultTab);
  console.log('data', data);
  // 自动跳转到默认 tab
  if (liveSwiper) {
    if (defaultTab === 3) {
      // 多直播
      liveSwiper.slideTo(1, 0, false);
    } else if (defaultTab === 2) {
      // 图文
      liveSwiper.slideTo(1, 0, false);
    } else if (defaultTab === 4) {
      // 评论
      liveSwiper.slideTo(2, 0, false);
    }
  }

  // // 只要 defaultTab=3 或者 有多直播数据，都强制渲染多直播 tab
  // const needShowSceneTab = (data && data.length > 1) || defaultTab === 3;
  // if (needShowSceneTab) {
  //   const sceneTitleHtml = `<div data-name="scene" class="live-slide-title-box">
  //     <div class="live-slide-title-text">多直播</div>
  //     <div class="live-slide-title-underline"></div>
  //   </div>`;
  //   $('.live-slide-title-list')
  //     .find('div[data-name="baseinfo"]')
  //     .after(sceneTitleHtml);
  //   const slideHeight = $('.live-slide').height();
  //   const slideHtml = `<div class="live-slide live-scene-content swiper-slide" style="height: ${slideHeight}px">
  //     <div class="live-scene-body" id="live-scene-body"></div>
  //   </div>`;
  //   $('.live-baseinfo-content').after(slideHtml);
  //   liveSlideNames.splice(1, 0, 'scene');
  //   if (liveSwiper) {
  //     liveSwiper.updateSlides();
  //     if (defaultTab === 3) {
  //       // 多直播
  //       liveSwiper.slideTo(1, 0, false);
  //     } else if (defaultTab === 2) {
  //       // 图文
  //       liveSwiper.slideTo(1, 0, false);
  //     } else if (defaultTab === 4) {
  //       // 评论
  //       liveSwiper.slideTo(3, 0, false);
  //     }
  //   }
  // } else if (liveSwiper) {
  //   if (defaultTab === 2) {
  //     liveSwiper.slideTo(1, 0, false);
  //   } else if (defaultTab === 4) {
  //     liveSwiper.slideTo(2, 0, false);
  //   }
  // }
  // if (!data || data.length === 0) {
  //   $('#live-scene-body').html(
  //     '<img class="live-nolive-empty" src="https://pgcoss.gzcmc.net/news-static/xinhuacheng/2024-03-14/images/content-empty-abd9bb35.png">',
  //   );
  // }

  if (data && data.length > 1 && liveSwiper) {
    renderSceneList(data);
    $('#live-scene-body').on('click', '.live-scene-box', (evt) => {
      const { id } = evt.currentTarget.dataset;
      if (currentSceneId === id) {
        return;
      }
      const live = liveSceneList.find((item) => item.id === id);
      if (live) {
        setSceneLive(live);
      }
    });
    if (nextJsonUrl) {
      nextLiveJsonUrl = nextJsonUrl;
      $('#live-scene-body').on(
        'scroll',
        throttle((scrollEvt) => {
          const { offsetHeight, scrollHeight, scrollTop } =
            scrollEvt.currentTarget;
          if (offsetHeight + scrollTop + 20 > scrollHeight) {
            if (!isLoading && nextLiveJsonUrl) {
              addLiveLoadingIcon(
                $('#live-scene-body'),
                $(scrollEvt.currentTarget),
                scrollTop,
              );
              isLoading = true;
              getNextLiveScene();
            }
          }
        }, 250),
      );
    }
  }
};

/**
 * 图文直播类型 2: 单图 3: 多图 4: 视频
 * 若图文直播的类型为单图，则返回一个图片的html
 * 若图文直播的类型为多图，则返回多个图片的html
 * 若图文直播的类型为视频，则返回视频的html
 * @param nolive
 * @returns
 */
const getMediaContent = (nolive: RMT.NoLiveJsonData) => {
  let mediaContent = '';
  switch (nolive.reportType) {
    case 2: {
      if (nolive.imgNum === 1) {
        mediaContent = `<div class="live-nolive-image-1"><img style="width: ${
          nolive.isUprightimg ? '33%' : '100%'
        }" class="live-nolive-image" src="${lazyImage}" data-src="${
          nolive.reportImg1_s || nolive.reportImg1
        }"></div>`;
      }
      break;
    }
    case 3: {
      const images = [];
      for (let i = 0; i < nolive.imgNum; i += 1) {
        const keys = [`reportImg${i + 1}_s`, `reportImg${i + 1}`];
        //  @ts-expect-error will be exist
        if (nolive[keys[0]] || nolive[keys[1]]) {
          images.push(
            `<img class="live-nolive-image" src="${lazyImage}" data-src="${
              //  @ts-expect-error will be exist
              nolive[keys[0]] || nolive[keys[1]]
            }">`,
          );
        }
      }
      if (nolive.imgNum === 2 || nolive.imgNum === 4) {
        mediaContent = `<div class="live-nolive-image-2">${images.join(
          '',
        )}</div>`;
      } else {
        mediaContent = `<div class="live-nolive-image-3">${images.join(
          '',
        )}</div>`;
      }
      break;
    }
    case 4: {
      mediaContent = `<div class="live-nolive-video-box">
        <video webkit-playsinline="true" playsinline="true" x5-video-player-type="h5" class="live-nolive-video video-js" src="${
          nolive.videoOsspath || nolive.videoPath
        }" poster="${
          nolive.videoCover_s || nolive.videoCover || lazyImage
        }"></video>
      </div>`;
      break;
    }
    default: {
      mediaContent = '';
    }
  }
  return `<div class="live-nolive-media">${mediaContent}</div>`;
};

let noliveRightWidth = '';
let noliveLinkRightWidth = '';
/**
 * 图文直播类型 1: 纯图文 2: 单图 3: 多图 4: 视频
 * 返回图文直播的html，若图文直播类型不为1，则存在多媒体内容
 * @param nolive
 * @returns
 */
const getNoliveHtml = (nolive: RMT.NoLiveJsonData) => {
  const noliveAuthor = `<div class="live-nolive-author">${nolive.reporterName}</div>`;
  const noliveTitle = nolive.title
    ? `<div class="live-nolive-title">${nolive.title}</div>`
    : '';
  const noliveContent = `<div class="live-nolive-text">${nolive.content}</div>`;
  const noliveTime = `<div class="live-nolive-time">${(nolive.reportTime || nolive.createtime).substring(5, 16)}</div>`;
  const noliveIconBox = `<div class="live-nolive-icon-box">
      <img src="${noliveIcon}" class="live-nolive-icon">
      <div class="live-nolive-line"></div>
    </div>`;
  const mediaContent = getMediaContent(nolive);
  const noliveRight = `<div class="live-nolive-right" style="width: ${noliveRightWidth}">${noliveTime}${noliveAuthor}${noliveTitle}${mediaContent}${noliveContent}</div>`;
  return `<div class="live-nolive-box">${noliveIconBox}${noliveRight}</div>`;
};

/**
 * 若为活动、商品的图文链接，则返回链接框
 * @param nolive
 * @returns
 */
const getNoliveLinkHtml = (nolive: RMT.NoLiveJsonData) => {
  const noliveAuthor = `<div class="live-nolive-author">${nolive.reporterName}</div>`;
  const noliveTime = `<div class="live-nolive-time">${(nolive.reportTime || nolive.createtime).substring(5, 16)}</div>`;
  const linkContent = `<div class="live-nolive-link-text">${
    nolive.activityContent || nolive.commodityContent
  }</div>`;
  const linkTitle = `<div class="live-nolive-link-title">${nolive.title}</div>`;
  const linkImage = `<img src="${lazyImage}" data-src="${
    nolive.reportImg1_s || nolive.reportImg1
  }" class="live-nolive-link-image" >`;
  const linkBtn = `<div class="live-nolive-link-btn-box"><a href="${
    nolive.activityLink || nolive.commodityLink
  }" target="_blank"><div class="live-nolive-link-btn">${
    nolive.activityLink ? '进入活动' : '马上抢'
  }</div></a></div>`;
  const noliveIconBox = `<div class="live-nolive-icon-box">
      <img src="${noliveIcon}" class="live-nolive-icon">
      <div class="live-nolive-line"></div>
    </div>`;
  const noliveLinkRight = `<div class="live-nolive-link-right" style="width: ${noliveLinkRightWidth}">${linkTitle}${linkContent}${linkBtn}</div>`;
  const noliveLinkBox = `<div class="live-nolive-link-box">${linkImage}${noliveLinkRight}</div>`;
  const noliveRight = `<div class="live-nolive-right" style="width: ${noliveRightWidth}">${noliveTime}${noliveAuthor}${noliveLinkBox}</div>`;
  return `<div class="live-nolive-box">${noliveIconBox}${noliveRight}</div>`;
};

/**
 * 渲染图文直播内容
 * 由于内容存在图片，为了避免图片加载慢，增加lazyload
 * 若内容存在视频，使用videojs插件优化视频样式，并增加视频的播放监听
 * 当播放图文内容的视频时，顶部的直播视频暂停
 * 当轮播滚动走时，在图文内容的视频暂停
 * @param list
 */
const renderNoliveList = (list: RMT.NoLiveJsonData[]) => {
  const htmls = list.map((item) => {
    if (item.activityLink || item.commodityLink) {
      return getNoliveLinkHtml(item);
    }
    return getNoliveHtml(item);
  });
  $('#live-nolive-body').append(htmls.join(''));
  const images = $('#live-nolive-body').find('.live-nolive-image');
  const noliveImages = images.filter(
    (index, el) => $(el).attr('src') !== $(el).attr('data-src'),
  );
  const linkImages = $('#live-nolive-body').find('.live-nolive-link-image');
  const noliveLinkImages = linkImages.filter(
    (index, el) => $(el).attr('src') !== $(el).attr('data-src'),
  );
  // eslint-disable-next-line no-new
  new Lazyload([...noliveImages, ...noliveLinkImages]);
  const tVideos = $('.live-nolive-video');
  if (tVideos && tVideos.length) {
    tVideos.each((index, el) => {
      if (!el.className.includes('vjs')) {
        const player = videojs(el, {
          aspectRatio: '16:9',
          controls: true,
          playbackRates: [0.75, 1, 1.25, 1.5, 2],
        });
        player.on('play', () => {
          if (!liveVideoPlayer.paused()) {
            liveVideoPlayer.pause();
          }
        });
        nolivePlayers.push(player);
      }
    });
  }
};

let noliveIsDesc = true;
let nextNoliveJsonUrl: boolean | string = '';
let nolivePageNum = 1;
const addNoliveFinish = () => {
  if (!nextNoliveJsonUrl) {
    $('#live-nolive-body').off('scroll');
    $('#live-nolive-body').append(
      '<div class="live-content-finish">已加载全部内容</div>',
    );
  }
};
/**
 * 获取更多图文直播
 * 若已发布，则通过json获取数据
 * 若未发布，则通过接口获取数据
 * @returns
 */
const getNextNolive = async () => {
  let res: RMT.NoLiveJson | RMT.PreviewNoLiveReport;
  if (
    staticType === 1 &&
    typeof nextNoliveJsonUrl === 'string' &&
    nextNoliveJsonUrl
  ) {
    res = await fetchNoLiveJson(nextNoliveJsonUrl);
    if (res.data && res.data.length) {
      renderNoliveList(res.data);
    }
    nextNoliveJsonUrl = res.nextJsonUrl;
  } else if (
    staticType === 7 &&
    typeof nextNoliveJsonUrl === 'boolean' &&
    nextNoliveJsonUrl
  ) {
    nolivePageNum += 1;
    res = await fetchPreviewNoliveReport(liveId, nolivePageNum);
    if (res.list && res.list.length) {
      renderNoliveList(res.list);
    }
    nextNoliveJsonUrl = res.pageNum < res.pages;
  }
  isLoading = false;
  const loadingDom = $('#live-nolive-body').find('.live-content-loading');
  if (loadingDom && loadingDom.length) {
    loadingDom.remove();
  }
  addNoliveFinish();
};
let isInitNolive = false;
let noliveTimeout = 0;
let firstNoliveId = '';
/**
 * 初始化图文直播
 * 对图文直播的图片增加点击监听，若在微信中，则可以预览图片
 * 对图文直播增加点击监听，点击后增加active
 * 对图文直播的正/倒序浏览增加点击监听，重新渲染图文直播的内容
 * 增加定时发送请求，若内容滚动时，则暂停倒计时
 * 增加滚动监听，若滚动到底，则请求更多图文直播
 * @returns
 */
const initNolive = async () => {
  noliveRightWidth = `${bodyWidth > 650 ? 650 - 78 : bodyWidth - 58}px`;
  noliveLinkRightWidth = `${bodyWidth > 650 ? 650 - 210 : bodyWidth - 170}px`;
  $('#live-nolive-body').off('scroll');
  $('.live-nolive-content').find('.live-content-finish').remove();
  if (!isInitNolive) {
    isInitNolive = true;
    $('#live-nolive-body').on('click', '.live-nolive-image', (evt) => {
      const currentSrc = $(evt.currentTarget).attr('src');
      const imageParent = $(evt.currentTarget).parent();
      const images: string[] = [];
      let currentIndex = 0;
      $(imageParent)
        .find('.live-nolive-image')
        .each((_, el) => {
          const src = $(el).attr('src');
          if (src === currentSrc) {
            currentIndex = images.length;
          }
          if (src) {
            images.push(src);
          }
        });
      if (version.weixin) {
        wx.previewImage({
          urls: images,
          current: images[currentIndex],
        });
      }
    });
    $('#live-nolive-body').on('click', '.live-nolive-box', (evt) => {
      $('.live-nolive-box-active').removeClass('live-nolive-box-active');
      $(evt.currentTarget).addClass('live-nolive-box-active');
    });
    $('.live-nolive-content').on('click', '.live-upside-down', () => {
      noliveIsDesc = !noliveIsDesc;
      const firstLiveNoliveBox =
        $('#live-nolive-body').find('.live-nolive-box')[0];
      if (firstLiveNoliveBox) {
        firstLiveNoliveBox.scrollIntoView();
      }
      initNolive();
    });
  }
  let data: RMT.NoLiveJsonData[];
  let res: RMT.NoLiveJson | RMT.PreviewNoLiveReport;
  if (staticType === 1) {
    res = await fetchNoLiveJson(noliveIsDesc ? noLiveJsonDesc : noLiveJson);
    data = res.data;
    nextNoliveJsonUrl = res.nextJsonUrl;
    if (noliveTimeout) {
      window.clearTimeout(noliveTimeout);
    }
    noliveTimeout = window.setTimeout(() => {
      initNolive();
    }, 30 * 1000);
  } else {
    res = await fetchPreviewNoliveReport(liveId, nolivePageNum);
    data = res.list;
    nextNoliveJsonUrl = res.pageNum < res.pages;
  }
  $('.live-upside-down').remove();
  if (data && data.length && firstNoliveId !== data[0].id) {
    firstNoliveId = data[0].id;
    if (staticType === 1) {
      $('.live-nolive-content').append(
        `<div class="live-upside-down">
          <img class="live-upside-down-img" src="${liveUpsideDown}">
          <span class="live-upside-down-text">${
            noliveIsDesc ? '倒序浏览' : '正序浏览'
          }</span>
        </div>`,
      );
    }
    $('#live-nolive-body').empty();
    renderNoliveList(data);
    $($('#live-nolive-body').find('.live-nolive-box')[0]).addClass(
      'live-nolive-box-active',
    );
    addNoliveFinish();
    if (nextNoliveJsonUrl) {
      $('#live-nolive-body').on(
        'scroll',
        throttle((scrollEvt) => {
          if (staticType === 1) {
            if (noliveTimeout) {
              window.clearTimeout(noliveTimeout);
            }
            noliveTimeout = window.setTimeout(() => {
              initNolive();
            }, 30 * 1000);
          }
          const { offsetHeight, scrollHeight, scrollTop } =
            scrollEvt.currentTarget;
          if (offsetHeight + scrollTop + 20 > scrollHeight) {
            if (!isLoading && nextNoliveJsonUrl) {
              addLiveLoadingIcon(
                $('#live-nolive-body'),
                $(scrollEvt.currentTarget),
                scrollTop,
              );
              isLoading = true;
              getNextNolive();
            }
          }
        }, 250),
      );
    }
  }
};
// // 设置预览标题样式
// const setFontFamily = (
//   elements: NodeListOf<HTMLElement>,
//   fontFamily: string,
// ) => {
//   elements.forEach((element) => {
//     // 创建一个新的变量来保存对 element 的引用
//     const el = element;
//     console.log('setFontFamily', element);
//     el.style.fontFamily = fontFamily;
//   });
// };

// const getUrlQuery = (url = window.location.href) => {
//   console.log('getUrlQuery', url);
//   if (url.includes('doPreview')) {
//     console.log('doPreview');
//     setFontFamily(
//       document.querySelectorAll('.live-title'),
//       'SimHei, sans-serif !important',
//     );
//   }
// };

const getUrlQuery = () => {
  // 判断URL中是否存在doPreview
  if (window.location.href.indexOf('doPreview') !== -1) {
    // 获取所有class为live-title的元素
    const elements = document.getElementsByClassName('live-title');

    // 遍历所有匹配的元素
    for (let i = 0; i < elements.length; i += 1) {
      // 给每个元素添加一个CSS类
      elements[i].classList.add('custom-font');
    }
  }
};

(() => {
  getUrlQuery();
  YouMeng.initYoumeng();
  YouMeng.initYoumengLog();
  YouMeng.pushRecord(
    { article_id: liveId },
    'gzcmc.xhc.h5.manuscript.view.click',
    'onload',
  );
  NanFang.init().then(() => {
    NanFang.openArticle(liveId);
  });
  if (Number(liveState) === 1) {
    initPreviewBox();
  } else if (Number(liveState) === 2 || Number(liveState) === 3) {
    initPlayingAndPlaybackBox();
    initSwiper();
    initSceneVisitCount();
    initLiveComment();
    if (Number(liveType) === 2) {
      initLiveScene();
      initNolive();
    }
  }
  if (staticType === 1) {
    initSiteJson();
    getBrowerAppId(() => {
      addReadCount();
    });
    initWxSdk({
      wxShare: {
        title: getSingleValueFromInput('shareTitle') || document.title,
        desc: getSingleValueFromInput('shareDesc') || '',
        imgUrl: (getSingleValueFromInput('shareImgUrl') ||
          process.env.DEFAULT_SHARE_IMAGE) as string,
      },
    });
  }
})();
